export default "__VITE_ASSET__D6jyp_4n__"